import { createAppSlice } from '../app.slice';

const initialState = {
  id: '',
  name: '',
};

export const openedFileSlice = createAppSlice({
  name: 'openedFileSlice',
  initialState,
  reducers: {
    selectOpenedFile: (state, action) => {
      state.id = action.payload.fileId;
      state.name = action.payload.fileName;
    },
  },
});
